/**
 * Canonical labels + tones for the DB-side classification (admin_sub_classes)
 * and inbox severities. The class itself is computed in the database; this
 * file only decides how it renders.
 */
export type Tone = 'stone' | 'indigo' | 'emerald' | 'amber' | 'rose' | 'violet';

export const CLASS_META: Record<string, { label: string; tone: Tone }> = {
  paying:         { label: 'Paying',          tone: 'emerald' },
  cancelling:     { label: 'Cancelling',      tone: 'amber' },
  comped:         { label: 'Comped',          tone: 'violet' },
  comped_expired: { label: 'Comp expired',    tone: 'amber' },
  lapsed:         { label: 'Lapsed',          tone: 'rose' },
  past_due:       { label: 'Past due',        tone: 'rose' },
  trialing:       { label: 'Trialing',        tone: 'indigo' },
  free:           { label: 'Free',            tone: 'stone' },
  canceled:       { label: 'Cancelled',       tone: 'stone' },
};

export const classMeta = (c: string | null | undefined) =>
  CLASS_META[c ?? 'free'] ?? { label: c ?? 'Free', tone: 'stone' as Tone };

export const SEV_META: Record<string, { label: string; tone: Tone }> = {
  act:   { label: 'Act now', tone: 'rose' },
  watch: { label: 'Watch',   tone: 'amber' },
  info:  { label: 'Info',    tone: 'indigo' },
};

export interface InboxItem {
  key: string;
  severity: 'act' | 'watch' | 'info';
  title: string;
  n: number;
  url: string;
}

export interface SubClassRow {
  user_id: string;
  plan: string | null;
  status: string;
  stripe_subscription_id: string | null;
  stripe_customer_id: string | null;
  current_period_end: string | null;
  cancel_at_period_end: boolean | null;
  billing_interval: string | null;
  created_at: string;
  updated_at: string;
  class: string;
  mrr: number;
}
